import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, shareReplay, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegulatoryDataService {
  private cache$: Observable<any> | null = null;
  private readonly DATA_URL = 'assets/regulary-data.json';

  constructor(private http: HttpClient) {}

  getRegulatoryData(): Observable<any> {
    if(!this.cache$) {
      if(!environment.production) {
        console.log('RegulatoryDataService: Fetching regulatory data');
      }

      this.cache$ = this.http.get(this.DATA_URL).pipe(
        tap(() => {
          if(!environment.production) {
            console.log('RegulatoryDataService: Data cached');
          }
        }),
        shareReplay(1),
        catchError((error: any) => {
          if(!environment.production) {
            console.error('RegulatoryDataService: Load error', error);
          }
          this.cache$ = null;
          return throwError(() => error);
        })
      );
    }

    return this.cache$;
  }

  clearCache(): void {
    this.cache$ = null;
  }

  preload(): void {
    this.getRegulatoryData().subscribe();
  }
}
